import { MDSMenuItemProps } from "@/mds/components/menu/menu-item";
import { MDSShortcutKeyCombo } from "@/mds/components/shortcut-key";
import { resolveHotkey } from "@/modules/keyboard-shortcuts/platform";
import {
  getShortcutBinding,
  ShortcutAction,
  ShortcutBindingAction,
} from "@/modules/keyboard-shortcuts/registry";

type GetShortcutMenuItemRightAddonArgs = {
  action: ShortcutAction | ShortcutBindingAction;
};

export const getShortcutMenuItemRightAddon = ({
  action,
}: GetShortcutMenuItemRightAddonArgs): MDSMenuItemProps["rightAddon"] | undefined => {
  const binding = getShortcutBinding(action);
  if (!binding) {
    return undefined;
  }

  const hotkey = resolveHotkey(binding);

  return () => <MDSShortcutKeyCombo hotkey={hotkey} />;
};
